import { components } from "@/api-schema";
import { RelocationOrderStatus, RelocationOrderTransportMethod } from "@/api-schema-enums";

type RelocationOrder = Pick<components["schemas"]["RelocationOrder"], "orderedBy" | "status" | "transportMethod">;

export function canDeleteOwnRelocationOrder(relocationOrder: RelocationOrder, userUuid?: string | null): boolean {
  if (!userUuid || relocationOrder.orderedBy?.uuid !== userUuid) {
    return false;
  }

  if (relocationOrder.transportMethod === RelocationOrderTransportMethod.OwnAxle) {
    return relocationOrder.status === RelocationOrderStatus.TransportCompanyAwaitingDeliveryAcceptance;
  }

  if (relocationOrder.transportMethod === RelocationOrderTransportMethod.TransportCompany) {
    return relocationOrder.status === RelocationOrderStatus.TransportCompanyAwaitingPickupDate;
  }

  return false;
}
